import {
    BASIC_COMPOSITION,
    CATEGORY_TYPE,
    IS_NEXT_CARD,
    NO_ThANKS_CARD,
    REDIRECTION,
} from "@constants";

import {
    groupWorkflowShopCard,
    orderItemsToDelete,
} from "@components/OrderTaking/Helpers";

export function skipStep(currentWorkflow, handleWorkDialogOnCLickEvent) {
    if (currentWorkflow !== undefined) {
        const isSuspended =
            currentWorkflow?.workflow[currentWorkflow.index].Items[0]
                .isSuspended;
        const hasAddSale =
            currentWorkflow?.workflow[currentWorkflow.index].Items[0]
                .haveAdditionalSale;
        const isStepSkipped =
            currentWorkflow?.workflow[currentWorkflow.index].isCreational;
        const isOutOfStockProduct =
            currentWorkflow?.workflow[currentWorkflow.index].Items[0]
                .outOfStock;

        const hasWorkflow =
            currentWorkflow?.workflow[currentWorkflow.index].Items[0]
                .haveWorkflow;
        if (
            hasWorkflow === false &&
            isOutOfStockProduct === false &&
            isStepSkipped === true &&
            hasAddSale === false &&
            isSuspended !== true &&
            currentWorkflow?.workflow[currentWorkflow.index]
                ?.minNbrOfChoices === 1 &&
            currentWorkflow?.workflow[currentWorkflow.index].maxNbrOfChoices ===
                1 &&
            currentWorkflow?.workflow[currentWorkflow.index].NbrOfChoices <
                currentWorkflow?.workflow[currentWorkflow.index]
                    .minNbrOfChoices &&
            currentWorkflow?.workflow[currentWorkflow.index].Items.length === 1
        ) {
            handleWorkDialogOnCLickEvent();
        }
    }
}
export function getProductType(product, currentWorkflow) {
    return (product?.isRedirect && currentWorkflow) ||
        product.isRedirect ||
        product.type === CATEGORY_TYPE
        ? REDIRECTION
        : product?.type === BASIC_COMPOSITION
        ? BASIC_COMPOSITION
        : product?.type === NO_ThANKS_CARD
        ? NO_ThANKS_CARD
        : product?.type === IS_NEXT_CARD
        ? IS_NEXT_CARD
        : "";
}
export function productHaveOneOption(product) {
    return product?.optionsKiosk?.Options.length === 1 &&
        product?.optionsKiosk?.Options[0].listOptions.length > 0
        ? product?.optionsKiosk?.Options[0].listOptions.length === 1
            ? true
            : false
        : false;
}
export const getItemQuantityInStep = (
    product,
    ExistOrderItems,
    orderWorkflowItemSlice,
    currentWorkflow,
    listItemsToBeDeleted
) => {
    let quantity = 0;
    ExistOrderItems.splice(0, ExistOrderItems.length);
    if (Object.keys(orderWorkflowItemSlice.item.shopCart).length > 0) {
        let OrderItemsworkflow = currentWorkflow.workflow[
            currentWorkflow.index
        ].path.reduce((prev, key) => {
            return prev[key.name] || {};
        }, orderWorkflowItemSlice.item.shopCart);

        if (Object.keys(OrderItemsworkflow).length > 0) {
            const currentlistItemsToBeDeleted = Object.keys(
                OrderItemsworkflow
            ).reduce((prev, curr) => {
                if (OrderItemsworkflow[curr].iuud === product.iuud) {
                    quantity += OrderItemsworkflow[curr].quantity;
                    return {
                        ...prev,
                        [curr]: OrderItemsworkflow[curr],
                    };
                }
                return { ...prev };
            }, {});
            ExistOrderItems.push(
                ...groupWorkflowShopCard(currentlistItemsToBeDeleted)
            );
            listItemsToBeDeleted.push(
                ...orderItemsToDelete(currentlistItemsToBeDeleted)
            );
        }
    }

    return quantity;
};
